.stack {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding: 16px;
}
